<section class="start-chat" aria-labelledby="start-chat-heading">
    <h3 class="ap-margin-bottom-0" id="start-chat-heading">{{ 'start.chat.heading' | apContent }}</h3>
    <p class="ap-margin-bottom-4">{{ 'start.chat.description' | apContent }}</p>
    <ap-button type="button" variant="primary" iconName="chat" (click)="onOpenChat()">
        {{ 'start.chat.button.label' | apContent }}
    </ap-button>
</section>
